import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_services", link: "/management/services" }
];

const ServicesListing = Loadable({
  loader: () => import("container/management/services/listing"),
  loading() {
    return <Loader />;
  }
});
const ManagementServicesAdd = Loadable({
  loader: () => import("container/management/services"),
  loading() {
    return <Loader />;
  }
});

export const serviceRoutes: IRoute[] = [
  {
    path: "/management/services",
    element: <ServicesListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/management/services/details/:id?",
    element: <ManagementServicesAdd />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  }
];
